import React, { Suspense } from "react";
import { Spin } from "antd";

const TermsContainer = React.lazy(
  () => import("../../../modules/Terms/components/index")
);

const TermsPage = () => (
  <Suspense fallback={<Spin />}>
    <TermsContainer />
  </Suspense>
);

export default TermsPage;
